/**
 * Focus: A class that focus to targets elements 
 *
 * Put two arguments on the element that triggers the toggle:
 * - data-focus = Target that will be set focus
 * - example: data-focus='.topbar .search-input'
 *
 */
;(function ($, _, window) { // eslint-disable-line no-extra-semi
    'use strict';

    /**
     * Focus component constructor
     * @param $element
     * @param target
     * @param auto
     */
    var NinjaForm = function ($element, targets) {
        this._$el = $element;
        this._targets = targets;
        this._options = NinjaForm.config;
        this.current = 0;
        this.$steps = null;

        this.fields = this._$el.find('.nf-field-container');
        this.steps = []
        this._$stepswrapper = $('<div class="form-step-wrapper" />');
        this._$buttons = $('<button class="form-step-button type-prev" type="button" >Vorige</button><button class="form-step-button type-next" type="button" >Volgende</button>');
        this._$progress =   $('<header class="form-steps-progress" />');
       this.initSteps();
    };

    /*
     * Create Steps ninja forms by hr spacer
     */
    NinjaForm.prototype.initSteps = function() {
        var self = this;
        var newFormFields = [] //
        // console.log(this.fields);

        // create Array
        this.fields.each(function(index, el) {
            newFormFields.push(el);
            
            if($(el).hasClass('hr-container')) {
                self.steps.push(newFormFields);
                newFormFields = [];
            }

        });

        //Create steps container
        $.each( this.steps, function( key, el ) {
        
            var $container = $('<div class="form-step-wrapper-item" />');

            $.each(el, function(k, v){
                $container.append(v);
            });

            self._$stepswrapper.append($container);


            // console.log(el);
        });
        self._$el.find('.nf-form-content').html(self._$stepswrapper);
        
        self.$steps = self._$el.find('.form-step-wrapper-item');
        self.setStep();
        self.setPaging();
        self.setProgress();
        self.updateSteps();
    }

    //Progress
    NinjaForm.prototype.setProgress = function() {
        var self=this;
        
        $('<span class="form-steps-progress-item" />').appendTo(self._$progress);
        
        // for (var i = 0; i < self.steps.length; i++) {
        //     $('<span class="form-steps-progress-item" />').text(i).appendTo(self._$progress);
        // }

        this._$stepswrapper.prepend(self._$progress);
    }

    //Paging
    NinjaForm.prototype.setPaging = function() {
        var self = this,
            $paging = $('<div class="form-step-paging"></div>').append(self._$buttons);

        this._$stepswrapper.append($paging);
        
        self._$buttons.bind('click', function(e){
            
            if($(this).hasClass('type-next')) {
                
                self.current++;   
            }

            if($(this).hasClass('type-prev')) {
                
                self.current--;
            }

            self.updateSteps();

            $('html, body').animate({
                scrollTop: self._$el.offset().top - 120
            }, 800);
        });

        
    }

    NinjaForm.prototype.updateSteps = function() {
        var self = this;
        // console.log(this.current, self.$steps.length);
        
        if(this.current < 1) {
            this.current = 0;
            $(this._$buttons[0]).addClass(this._options.classes.hidden); //pagination 
            
        } else {
            $(this._$buttons[0]).removeClass(this._options.classes.hidden); //pagination 
        }

        if(this.current >= (self.$steps.length - 1)) {
            this.current = self.$steps.length -1 ;
            $(this._$buttons[1]).addClass(this._options.classes.hidden);
        } else {
            $(this._$buttons[1]).removeClass(this._options.classes.hidden); //pagination 
        }

       

        self.setStep();

    }


    // Set Step;
    NinjaForm.prototype.setStep = function() {
        //updateProgress
        var self = this;

        $(this.$steps).removeClass(this._options.classes.active);
        $(this.$steps[this.current]).addClass(this._options.classes.active);
        // window.scroll(0,0);



        var width = (100/self.steps.length) * (self.current + 1);
        self._$progress.children().css('width', width +'%');
    }
    
    /*
     * Default settings
     */
    NinjaForm.config = {
        classes: {
            active: 'is--current',
            hidden: 'set--hidden'
        }  
    };
    
    /**
     * Attach new focus
     * @private
     */
    NinjaForm.prototype._attach = function() {
        
        var $el = $(this),
            $targets = $('body').find('.hr-container')

        new NinjaForm($el, $targets);
        
    };

    /**
     * Attach listeners to document
     */
    $(function () {
        /**
         * Travel through the DOM for data-focus attributes
         */        
        $(document).on( 'nfFormReady', function() {
            $('.nf-form-cont.form-wizard').each(NinjaForm.prototype._attach);
        });

        /**
         * Setup a jQuery chainable plugin for attaching to injected elements after page load
         * @type {*}
         */
/*
        $.fn.jqFocus = function () {
            $(this).each(Focus.prototype._attach);
        };
*/
    });

})(jQuery, _, window);